<div class="flex flex-column h-full">
  <div class="flex" style="height: auto">
    <div class="flex flex-column justify-content-start">
      <h2
        class="module-title cursor-pointer"
        routerLink="/configuration/email-template"
      >
        {{ "MENU.EMAIL-TEMPLATE" | translate | uppercase }}
      </h2>
    </div>
    <div class="flex mx-3">
      <i
        class="pi pi-angle-double-right"
        style="font-size: 2rem; color: var(--primary-color)"
      ></i>
    </div>
    <div class="flex flex-grow-1 flex-column justify-content-start">
      <h2 class="module-title">
        {{ "ENV.EDIT" | translate }}
        {{ "MENU.EMAIL-TEMPLATE" | translate | lowercase }}
      </h2>
    </div>
    <div
      class="flex flex-grow-1 flex-initial align-items-center justify-content-end"
    >
      <button
        pButton
        pRipple
        class="p-button-text"
        icon="pi pi-cloud-upload"
        label="{{ 'ENV.SAVE' | translate }}"
        [disabled]="!dataForm.valid"
        (click)="dataForm.ngSubmit.emit()"
        *ngIf="!processing"
      ></button>
    </div>
  </div>
  <p-divider styleClass="divider-slim"></p-divider>
  <div class="flex flex-grow-1 relative">
    <div class="card-form absolute h-full w-full">
      <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
        <form #dataForm="ngForm" (ngSubmit)="onSubmit()" class="px-4 py-3">
          <div class="flex flex-column lg:flex-row mb-4">
            <div class="flex flex-column flex-grow-1">
              <div
                class="p-float-label flex flex-column gap-2 mt-4 lg:mt-0 mb-4"
              >
                <input
                  pInputText
                  id="title"
                  name="title"
                  class="ng-dirty"
                  aria-describedby="title-help"
                  [(ngModel)]="form.subject"
                  maxlength="100"
                  required
                />
                <label Htmlfor="title">{{ "MENU.SUBJECT" | translate }}</label>
              </div>
              <div
                class="p-float-label flex flex-column gap-2 mt-4 lg:mt-0 mb-4"
              >
                <textarea
                  pInputTextarea
                  id="description"
                  name="description"
                  rows="5"
                  class="ng-dirty w-full"
                  [(ngModel)]="form.text"
                  required
                ></textarea>
                <label Htmlfor="title">{{
                  "MENU.TEXT-PLAIN" | translate
                }}</label>
              </div>

              <p-messages severity="warn">
                <ng-template pTemplate>
                  <div class="w-full">
                    <i class="pi pi-exclamation-triangle"></i>
                    {{ "ERROR.EMAIL-TEMPLATE-WARN" | translate }}
                  </div>
                </ng-template>
              </p-messages>

              <div class="flex flex-column lg:flex-row mb-4">
                <div class="flex flex-column flex-grow-1">
                  <div
                    class="p-float-label flex flex-column gap-2 mt-4 lg:mt-0 mb-4"
                    ngClass="col-12"
                  >
                    <app-html-template-editor
                      [(ngModel)]="form.html"
                      [ngModelOptions]="{ standalone: true }"
                      class="no-validation"
                    ></app-html-template-editor>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </p-scrollPanel>
    </div>
  </div>
</div>
